module.exports = __webpack_public_path__ + "img/m_contents_goodstore@2x.7bbf1f78.png";